import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {GraphData, GraphDates, GraphTypes} from '../../../shared/types/nso-data-portal/census-data';
import {
  OrganizationInformationRestService
} from '../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
import {SelectItem} from 'primeng/api';
import {ChartDataLabelsPlugin} from '../../../shared/chart-plugins/chart-data-labels-plugin';
import {
  BAR_CHART_OPTIONS,
  DOUGHNUT_CHART_OPTIONS,
  LEGEND_CONFIG, LEGEND_CONFIG_BAR,
  LINE_CHART_OPTIONS
} from '../../../shared/types/nso-data-portal/charts/chart-options';
import {EntityInformationRestService} from '../../../shared/services/nso-data-portal/rest-services/entity-information-rest.service';
import {SearchEntityLevels} from '../../../shared/types/nso-data-portal/search-entity-levels';

@Component({
  selector: 'wsd-census-graphs',
  templateUrl: './census-graphs.component.html',
  styleUrls: ['./census-graphs.component.css']
})
export class CensusGraphsComponent implements OnChanges {

  @Input()
  entityId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  @Input()
  detailed: boolean;

  @Output()
  sendDetailsData = new EventEmitter();

  @Output()
  sendWidgetData = new EventEmitter();

  graphsData: GraphData = {} as GraphData;
  graphTypes: SelectItem[] = GraphTypes;
  graphYears: SelectItem[] = GraphDates;
  selectedType: string = GraphTypes[0].value;
  selectedBarYear: string = GraphDates[0].value;
  selectedLineYear: string = GraphDates[1].value;

  readonly barOptions = BAR_CHART_OPTIONS;
  readonly doughnutOptions = DOUGHNUT_CHART_OPTIONS;
  readonly lineOptions = LINE_CHART_OPTIONS;

  constructor(private restService: OrganizationInformationRestService,
              private entityService: EntityInformationRestService,
              public chartDataLabelsPlugin: ChartDataLabelsPlugin) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadGraphs();
  }

  loadGraphs() {
    const options = {
      id: this.entityId,
      type: this.selectedType,
      barDate: this.selectedBarYear,
      lineDate: this.selectedLineYear
    };
    this.entityService.getEntityGraphData({
      options,
      detailed: this.detailed,
      level: this.entityId ? this.entityLevel : SearchEntityLevels.WORLD
    }).subscribe(
      res => {
        this.graphsData = res;
        if (this.detailed) {
          this.sendDetailsData.emit({
            beneficiaries: res.beneficiaries,
            beneficiariesGraph: res.beneficiariesGraph,
            shadowData: res.shadowData
          });
        } else {
          this.sendWidgetData.emit({
            censusUpdatedLastYear: res.censusUpdatedLastYear
          });
        }
      },
      () => {
        this.sendWidgetData.emit({
          censusUpdatedLastYear: false
        });
        this.graphsData = {} as GraphData;
      }
    );
  }

  get getYearsWithoutCurrent() {
    return this.graphYears.slice(1, this.graphYears.length);
  }

  get showDoughnut() {
    return this.selectedBarYear === this.graphYears[0].value;
  }

  get getBarChartOptions() {
    return this.showDoughnut ? this.barOptions : LEGEND_CONFIG_BAR;
  }
}
